/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

export type ScenarioNodeWithVideoUrlAllOf = {
  /** @nullable */
  animatedThumbnailUrl: string | null
  thumbnailUrl: string
  /**
   * HLS マスタープレイリストの未署名URL。READY のときのみ。null なら MP4(videoUrl) で再生
   * @nullable
   */
  hlsUrl: string | null
  videoUrl: string
}
